export const ProcessingRequestActionType = {
    ACTIVE: 'ACTIVE',
    DONE: 'DONE',
};

interface ISetActiveAction {
    type: typeof ProcessingRequestActionType.ACTIVE,
}

interface ISetDoneAction {
    type: typeof ProcessingRequestActionType.DONE,
}

export type ProcessingRequestActions = ISetActiveAction | ISetDoneAction

export function setActive(): ProcessingRequestActions {
    return {
        type: ProcessingRequestActionType.ACTIVE,
    }
}

export function setDone(): ProcessingRequestActions {
    return {
        type: ProcessingRequestActionType.DONE,
    }
}

